import type { AuthState, UiState, WorkspaceState } from './types';

const LEGACY_STORAGE_KEY = 'app';
const AUTH_STORAGE_KEY = 'app-auth';
const WORKSPACE_STORAGE_KEY = 'app-workspace';
const UI_STORAGE_KEY = 'app-ui';

type LegacyPersistedState = Partial<AuthState & WorkspaceState & UiState>;

const hasStorageKey = (key: string): boolean => localStorage.getItem(key) !== null;

export const migrateLegacyAppStorage = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (hasStorageKey(AUTH_STORAGE_KEY) || hasStorageKey(WORKSPACE_STORAGE_KEY) || hasStorageKey(UI_STORAGE_KEY)) {
    return;
  }

  const legacyRaw = localStorage.getItem(LEGACY_STORAGE_KEY);
  if (!legacyRaw) {
    return;
  }

  try {
    const parsed = JSON.parse(legacyRaw) as { state?: LegacyPersistedState };
    const legacyState = parsed.state;
    if (!legacyState) {
      return;
    }

    if (legacyState.user) {
      localStorage.setItem(
        AUTH_STORAGE_KEY,
        JSON.stringify({ state: { user: legacyState.user }, version: 0 })
      );
    }

    localStorage.setItem(
      WORKSPACE_STORAGE_KEY,
      JSON.stringify({
        state: {
          currentFolderId: legacyState.currentFolderId ?? null,
          folderType: legacyState.folderType ?? null,
          role: legacyState.role ?? 'owner',
        },
        version: 0,
      })
    );

    localStorage.setItem(
      UI_STORAGE_KEY,
      JSON.stringify({
        state: {
          mode: legacyState.mode,
          accent: legacyState.accent,
          isAuto: legacyState.isAuto,
          layout: legacyState.layout,
          currentLang: legacyState.currentLang,
          isInitialized: legacyState.isInitialized,
        },
        version: 0,
      })
    );
  } catch (error) {
    console.warn('Failed to migrate legacy app storage:', error);
  }
};
